// Types
import type { NotificationDashboardProps } from '@/utils/hooks/context/toast/types';

// Routes
import { DASHBOARD } from '@/routes/privateRoutes';

// Component
import Notification from '@/components/base/Notification';

const DashboardInvitationReceived = ({ notification }: NotificationDashboardProps) => {
    return (
        <Notification
            dataNotification={notification}
            goToUrl={`${DASHBOARD}?action=pending_invitations`}
            contentHidden={notification?.options?.hideContent ?? false}
            wide={notification?.options?.wide ?? true}>
            <Notification.Icon icon="dashboard" />
            <Notification.Content>
                <Notification.Title i18nKey="commons:notifications.dashboard_invitation_received.title" />
                <Notification.Description
                    i18nKey="commons:notifications.dashboard_invitation_received.description"
                    values={{
                        username: notification?.data?.invitation_from_user_name,
                        dashboard_title: notification?.data?.dashboard_title
                    }}
                />
            </Notification.Content>
        </Notification>
    );
};

export default DashboardInvitationReceived;
